(function(){
  function initHero(root){
    var hero = root.querySelector('[data-vp-hero]');
    if(!hero || hero.dataset.vpInit) return;
    hero.dataset.vpInit = '1';

    /* The inline script after the hero markup (vp-hero.liquid) normally
       reveals it as soon as it is parsed; these are the nets behind it --
       the theme editor's section reload, and a slow image. */
    var ready = function(){ hero.classList.add('is-ready'); hero.classList.add('media-in'); };
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){ hero.classList.add('is-ready'); });
    });
    addEventListener('load', ready);
    /* safety net: theme editor / slow connections never leave it hidden */
    setTimeout(ready, 2500);

    initFilm(hero);
  }

  /* ---- The film -------------------------------------------------------
     The still is already on screen; the film fades over it only once the
     browser reports it can play through. Revealing it on arrival alone shows
     a black rectangle for as long as the first frame takes to decode.

     Three things are handled that autoplay gets wrong on its own:
       * reduced motion -- the film is removed before it fetches a byte, so
         the preference costs bandwidth as well as movement
       * a refused autoplay -- Safari and data-saver modes reject play() and
         the promise rejects silently, leaving a frozen first frame over the
         poster. The film is dropped back out and the still stands.
       * a hero scrolled past -- it is paused off screen rather than decoding
         video nobody is looking at, and resumes when it comes back.
  */
  function initFilm(hero){
    var film = hero.querySelector('.vp-hero-media video');
    if(!film) return;

    /* Taken out before anything is fetched. The markup carries preload="none"
       and no autoplay attribute precisely so this costs nothing to honour --
       with either of them the browser would already have started the download
       by the time this line runs. */
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if(still && still.matches){ film.remove(); return; }

    /* ---- Which cut of the film this screen should have ----------------
       Three: a portrait cut for a phone, the ordinary wide one, and the full
       master for a screen big enough to show it. The choice is made here
       rather than with <source media="">, because a browser settles its
       source once when the element is parsed and never revisits it -- so a
       phone turned on its side, or a window dragged to another monitor, would
       be left on the wrong film.

       The measure is device pixels, not CSS pixels: a retina laptop reporting
       1728px wide is painting 3456 of them, and a 1080p film would be visibly
       soft on it. */
    var d = film.dataset;
    d.filmPoster = film.poster || '';
    var narrowUpto = parseInt(d.filmMobileUpto, 10) || 0;
    var wideFrom   = parseInt(d.filmWideFrom, 10) || 0;
    var playing    = '';

    function webmOk(){
      return film.canPlayType && film.canPlayType('video/webm; codecs="vp9"') !== '';
    }
    function ordinary(){
      var sources = film.querySelectorAll('source');
      for(var i = 0; i < sources.length; i++){
        if(film.canPlayType(sources[i].type)) return sources[i].src;
      }
      return sources.length ? sources[0].src : '';
    }
    function wanted(){
      var css = window.innerWidth || document.documentElement.clientWidth || 0;
      if(narrowUpto && css <= narrowUpto){
        var narrow = (webmOk() && d.filmMobileWebm) || d.filmMobileMp4;
        if(narrow) return narrow;
      } else if(wideFrom && d.filmWideMp4){
        if(css * (window.devicePixelRatio || 1) >= wideFrom) return d.filmWideMp4;
      }
      return ordinary();
    }

    /* Changing cut mid-loop must not read as a glitch: the film keeps its
       place in the loop and is not faded out, so what the eye sees is the
       same frame continuing at a different size. The still underneath covers
       the moment the new file takes to decode. */
    function choose(){
      var want = wanted();
      if(!want || want === playing) return;
      var at = film.currentTime || 0;
      playing = want;
      /* The poster is the film's own opening frame, so it has to change with
         the cut: a wide still behind a portrait film would show for the
         moment the new file takes to decode. */
      if(d.filmMobilePoster){
        var narrowNow = want === d.filmMobileMp4 || want === d.filmMobileWebm;
        film.poster = narrowNow ? d.filmMobilePoster : (d.filmPoster || film.poster);
      }
      film.setAttribute('src', want);
      film.load();
      film.addEventListener('loadedmetadata', function(){
        if(film.duration && isFinite(film.duration)) film.currentTime = at % film.duration;
        var p = film.play(); if(p && p.catch) p.catch(function(){});
      }, { once: true });
    }
    choose();

    /* Only the crossings matter, and a window being dragged crosses the same
       line many times a second. */
    var settling;
    addEventListener('resize', function(){
      clearTimeout(settling);
      settling = setTimeout(choose, 250);
    });

    var show = function(){ hero.classList.add('video-in'); };
    var drop = function(){ hero.classList.remove('video-in'); };

    if(film.readyState >= 3) show();
    else film.addEventListener('canplay', show, { once: true });
    film.addEventListener('error', drop);

    /* The markup does not autoplay; starting it is this script's job, which is
       what lets the preference above be free. */
    film.preload = 'auto';
    var attempt = film.play();
    if(attempt && typeof attempt.catch === 'function'){
      attempt.catch(function(){ drop(); });   /* autoplay refused: keep the still */
    }

    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ var p = film.play(); if(p && p.catch) p.catch(function(){}); }
          else film.pause();
        });
      }, { threshold: 0.01 }).observe(hero);
    }
  }

  function boot(){ initHero(document); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(e){ initHero(e.target); });
})();
